module.exports = __webpack_public_path__ + "img/about/80243-021.png";


//////////////////
// WEBPACK FOOTER
// ./img/about/80243-021.png
// module id = 18
// module chunks = 0